import React, { Component } from 'react'
import { Card, Image, Icon } from 'semantic-ui-react'
import { Route, Link } from 'react-router-dom'

class CustomCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            GeometryInfo: props.GeometryInfo,
            updateChildren: false,
            webp: 'https://cctech-ml-work.s3-accelerate.amazonaws.com/ml-mesh-segmentation/stl-upload/' + this.props.GeometryInfo.UID + '/input_geometry.webp',
            src: 'https://cctech-ml-work.s3-accelerate.amazonaws.com/ml-mesh-segmentation/stl-upload/' + this.props.GeometryInfo.UID + '/input_geometry.jpg'
        };
    }

    onMouseEnter(e) {
        // console.log(' !! hola mouse in on !!', e.target.dataset)
        this.setState({
            webp: 'https://cctech-ml-work.s3-accelerate.amazonaws.com/ml-mesh-segmentation/stl-upload/' + this.props.GeometryInfo.UID + '/output_geometry.webp',
            src: 'https://cctech-ml-work.s3-accelerate.amazonaws.com/ml-mesh-segmentation/stl-upload/' + this.props.GeometryInfo.UID + '/output_geometry.jpg'
        })
    }

    onMouseLeave(e) {
        // console.log(' !! awaie mouse in gone !!')
        this.setState({
            webp: 'https://cctech-ml-work.s3-accelerate.amazonaws.com/ml-mesh-segmentation/stl-upload/' + this.props.GeometryInfo.UID + '/input_geometry.webp',
            src: 'https://cctech-ml-work.s3-accelerate.amazonaws.com/ml-mesh-segmentation/stl-upload/' + this.props.GeometryInfo.UID + '/input_geometry.jpg'
        })
    }

    createCardElement(history) {
        let element = null;

        if (this.props.GeometryInfo.DisplayName === 'Create New') {
            element = (
                <div className={'sixteen wide mobile eight wide tablet four wide computer column'} style={{ paddingBottom: '2rem'}}>  
                    <Card fluid className={'no-border material-shadow-2dp hover-effect'}>
                        <Link to='/new'>
                            <Image className={'shbg-grey-pallet ninehundred fluid'} src={this.props.GeometryInfo.ThumbnailUrl} />
                        </Link>
                        <Card.Content className={'shbg-pallet white no-border'}>
                            <h3 className={'ui header font-weight-bold no-margin custom-link color-blue'}>
                                <Link to='/new'>{this.props.GeometryInfo.DisplayName}</Link>
                            </h3>
                            <h5 className={'ui grey header no-margin'}>
                                Upload a new geometry for mesh segmentation
                            </h5>
                        </Card.Content>
                        <Link className={'left-align-text spaced ui right labeled blue icon button no-radius'} to='/new'>
                            <i className={'right chevron icon'}></i>UPLOAD GEOMETRY
                        </Link>
                    </Card>                                               
                </div>
            );
        } else {
            element = (
                <div className={'sixteen wide mobile eight wide tablet four wide computer column'} style={{ paddingBottom: '2rem'}}>
                    <Card fluid className={'no-border material-shadow-2dp hover-effect'}>
                        <Link to={'/geom/' + this.props.GeometryInfo.UID}>
                            <Image onMouseEnter={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}
                                webp={this.state.webp}
                                src={this.state.src}
                            />
                        </Link>
                        <Card.Content className={'shbg-bluegrey-pallet fifty no-border'}>
                            <h3 className={'ui header font-weight-bold no-margin'}>
                                <Link to={'/geom/' + this.props.GeometryInfo.UID}>
                                    {this.props.GeometryInfo.DisplayName}
                                </Link>
                            </h3>
                            <div className={'cctech-services-title'}>
                                <Icon className={'text grey'} name='eye' />
                                <div className={'content'} style={{ paddingLeft: '0.5rem'}}>
                                    <h5 className={'ui grey header'}>
                                        {this.props.GeometryInfo.ViewCount} Views
                                    </h5>
                                </div>
                            </div>
                        </Card.Content>
                        <a className={'left-align-text spaced ui right labeled grey icon uppercase button no-radius'} href={'/geom/' + this.props.GeometryInfo.UID}>
                            <i className={'right chevron icon'}></i>Open Project
                        </a>
                    </Card>                                               
                </div>
            );
        }

        return element;
    }

    render() {
        return (
            <Route render={({ history }) => (
                this.createCardElement(history)
            )} />
        );
    }
}

export default CustomCard;